class PropertySingleSelectController {
  constructor(propertiesService) {
    this.propertiesService = propertiesService;
  }

  $onInit(){
    this.propertiesService.findAll(-1).then(result => {
        this.properties = result;
        this.properties.unshift({id: '', name: 'None', pod: {name: 'Select no property'}})
        this.property = (this.ngModel.$viewValue ? this.ngModel.$viewValue : '');
    });
  }

  updateValue(isOpen = false){
    if (!isOpen) {
      this.ngModel.$setViewValue(this.property);
      this.ngModel.$setTouched();
    }
  }
}

PropertySingleSelectController.$inject = [ 'propertiesService' ];

export default PropertySingleSelectController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.single.select.controller.js